<script>
import { Article, ArticleTag } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        widgets: []
      },
      tagOptions: [],
      redirectRoute: { name: 'Article List' }
    }
  },
  created() {
    this.fetchTags()
  },
  methods: {
    fetchTags() {
      const params = { page_size: 'max' }
      ArticleTag.fetch({}, { params }).then(res => {
        this.tagOptions = res.data.results.map(item => ({
          label: item.name,
          value: item.name
        }))
      })
    },
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [
            this.getGeneralTab(),
            this.getWidgetsTab(),
            this.getSEOTab()
          ]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne'
        },
        children: [
          new fields.Input({
            label: 'Tytuł',
            modelPath: [this, 'form', 'title'],
            multilingual: true,
            required: true
          }),
          new fields.Select({
            label: 'Tagi',
            modelPath: [this, 'form', 'tags'],
            multiple: true,
            filterable: true,
            allowCreate: true,
            options: this.tagOptions
          }),
          new fields.WYSIWYG({
            label: 'Lead',
            modelPath: [this, 'form', 'lead'],
            multilingual: true,
            required: true
          }),
          new fields.WYSIWYG({
            label: 'Treść',
            modelPath: [this, 'form', 'content'],
            multilingual: true,
            required: true
          }),
          new fields.Image({
            label: 'Zdjęcie',
            modelPath: [this, 'form', 'image']
          }),
          new fields.Switch({
            label: 'Ukryte',
            modelPath: [this, 'form', 'is_hidden']
          })
        ]
      }
    },
    getWidgetsTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Widgety'
        },
        children: [new fields.Widgets({ modelPath: [this, 'form', 'widgets'] })]
      }
    },
    getSEOTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'SEO'
        },
        children: [
          new fields.Input({
            label: 'Slug',
            modelPath: [this, 'form', 'slug'],
            multilingual: true,
            condition: !!this.form.id
          }),
          new fields.Input({
            label: 'Tytuł dla facebooka',
            modelPath: [this, 'form', 'og_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Opis dla facebooka',
            modelPath: [this, 'form', 'og_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Image({
            label: 'Zdjęcie dla facebooka',
            modelPath: [this, 'form', 'og_image']
          }),
          new fields.Input({
            label: 'Tytuł strony dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Opis dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_description'],
            type: 'textarea',
            multilingual: true
          })
        ]
      }
    }
  },
  computed: {
    service() {
      return Article
    }
  }
}
</script>
